import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog, DialogContent } from './v2/Dialog';
export default function FullScreenModal({ open, onClose, children }) {
    return (_jsx(Dialog, { open: open, onOpenChange: (isOpen) => !isOpen && onClose(), children: _jsx(DialogContent, { showCloseButton: false, className: "w-screen max-w-none", children: children }) }));
}
